// extracted by mini-css-extract-plugin
export default {"social_bar_container":"SocialBar_social_bar_container__wPzZu","social_bar":"SocialBar_social_bar__Pyadj"};